import AllhomesHeroCarousel from './allhomes-hero-carousel';
export default AllhomesHeroCarousel;